import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocalObservable } from "mobx-react-lite";
import { getTeamList, updateViewerCount } from "../services/IdealPoolService";
import StoreAction from "./StoreAction";

const initialState = {
  finishedteams: [],
};

const IdealPoolStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
  }));

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      getTeamList().then((value) => {
        if (value) {
          for (let i = 0; i < value.length; i++) {
            // store.addTeam(value[i]);
          }
        }
      });
    }
  });
  // return store;
};

export default IdealPoolStore;
